module.exports = __webpack_public_path__ + "static/media/melissamaryjenkinsart-IG.160e3d41.PNG";